/** @typedef {import('./prestige-types').PrestigeProfile} PrestigeProfile */
/** @typedef {import('./prestige-types').PrestigeTiers} PrestigeTiers */
/** @typedef {import('./prestige-types').PrestigeConnectorApiConfig} PrestigeConnectorApiConfig */
/** @typedef {import('./prestige-types').PrestigeRequestOptions} PrestigeRequestOptions */
/** @typedef {import('./prestige-types').PrestigeGetOptions} PrestigeGetOptions */
/** @typedef {import('./prestige-types').PrestigePostOptions} PrestigePostOptions */
/** @typedef {import('./prestige-types').ApiPaginatedResponse} ApiPaginatedResponse */
/** @template T
 * @typedef {import('./prestige-types').ApiResponse<T>} ApiResponse */
/** @typedef {import('./prestige-types').PrestigeGetPointsHistoryOptions} PrestigeGetPointsHistoryOptions */
/** @typedef {import('./prestige-types').PrestigePointsHistoryParams} PrestigePointsHistoryParams */
/** @typedef {import('./prestige-types').PrestigePointsHistoryEntry} PrestigePointsHistoryEntry */
/** @typedef {import('./prestige-types').PrestigePointsHistory} PrestigePointsHistory */
/** @typedef {import('./prestige-types').PrestigeMissionEntry} PrestigeMissionEntry */
/** @typedef {import('./prestige-types').PrestigeMissionParams} PrestigeMissionParams */
/** @typedef {import('./prestige-types').PrestigeGetMissionsOptions} PrestigeGetMissionsOptions */
/** @typedef {import('./prestige-types').PrestigeMissions} PrestigeMissions */
/** @typedef {import('./prestige-types').PrestigeClaimedReward} PrestigeClaimedReward */
/** @typedef {import('./prestige-types').PrestigeClaimReward} PrestigeClaimReward */
/** @typedef {import('./prestige-types').PrestigeAvailableRewardEntry} PrestigeAvailableRewardEntry */
/** @typedef {import('./prestige-types').PrestigeAvailableRewardParams} PrestigeAvailableRewardParams */
/** @typedef {import('./prestige-types').PrestigeGetAvailableRewardsOptions} PrestigeGetAvailableRewardsOptions */
/** @typedef {import('./prestige-types').PrestigeAvailableRewards} PrestigeAvailableRewards */
/** @typedef {import('./prestige-types').PrestigeSharePoints} PrestigeSharePoints */


const SHORTCODES = {
  download_represent_app_links: /* html */ `
  <div class="pt-2 mt-2" data-mission-shortcode="download_represent_app_links">
    <nav>
      <ul class="grid grid-cols-1 justify-items-start leading-[25px] gap-2">
        <li>
          <prestige-track action="represent_app_download">
            <a class="flex gap-2 items-center" href="https://apps.apple.com/gb/app/represent/id6466408934" target="_blank" rel="noopener">
              <span title="ios" class="inline-flex shrink-0" aria-hidden="true">
                <svg width="17" height="18" viewBox="0 0 9 12" fill="none" xmlns="http://www.w3.org/2000/svg" class="w-[17px] h-[18px]">
                  <path d="M6.65321 3.17605L6.63439 3.17407C6.3318 3.14224 6.0057 3.23146 5.64896 3.36608C5.58728 3.38936 5.51224 3.41901 5.43523 3.44944C5.32912 3.49137 5.21926 3.53478 5.13549 3.56501C4.98112 3.62072 4.7757 3.68704 4.572 3.68704C4.37654 3.68704 4.1882 3.63349 4.03766 3.58181C3.92443 3.54295 3.80016 3.49301 3.68557 3.44697C3.64771 3.43176 3.6109 3.41697 3.5759 3.40314C3.26497 3.28034 3.00002 3.19499 2.74892 3.20012L2.74641 3.20017C2.00705 3.21156 1.29533 3.64246 0.900835 4.33354L0.899543 4.33581L0.899537 4.3358C0.487936 5.0482 0.417078 5.96587 0.583331 6.90818C0.74876 7.84581 1.13928 8.74672 1.56943 9.37552C1.8079 9.71661 2.03507 10.0297 2.27748 10.257C2.51919 10.4838 2.71216 10.5647 2.88041 10.5588C3.11416 10.5491 3.26953 10.4841 3.51733 10.3803C3.5317 10.3743 3.54638 10.3682 3.56141 10.3619C3.84463 10.2437 4.19497 10.1097 4.71769 10.1097C5.24353 10.1097 5.59268 10.2557 5.86586 10.3718C6.12531 10.4821 6.28166 10.5473 6.53037 10.5416L6.53414 10.5415C6.75032 10.5382 6.94526 10.4465 7.15713 10.2487C7.37927 10.0412 7.58251 9.75254 7.81303 9.40795L7.81995 9.3976L7.82008 9.39768C8.09513 9.00789 8.27787 8.62177 8.38611 8.35561C8.24205 8.26388 8.07735 8.14236 7.91311 7.98627C7.46946 7.56463 7.02591 6.88499 7.01708 5.88569L6.65321 3.17605ZM6.65321 3.17605L6.67213 3.1766C6.91203 3.1836 7.49898 3.25845 7.99014 3.69923L6.65321 3.17605ZM5.44618 1.16782L5.44683 1.16707C5.62709 0.955602 5.8871 0.773873 6.15032 0.653514C6.07526 0.94183 5.931 1.21873 5.74356 1.45458C5.54565 1.68617 5.2884 1.86786 5.02524 1.96794C5.10384 1.67239 5.26235 1.38262 5.44618 1.16782Z" stroke="currentColor" fill="black"/>
                </svg>
              </span>
              <span class="text-black hover:text-[#737373]">iOS</span>
            </a>
          </prestige-track>
        </li>
        <li>
          <prestige-track action="represent_app_download">
            <a class="flex gap-2 items-center" href="https://play.google.com/store/apps/details?id=com.vennapps.representclo&hl=en" target="_blank" rel="noopener">
              <span title="android" class="inline-flex shrink-0" aria-hidden="true">
              <svg width="14" height="16" viewBox="0 0 14 16" fill="none" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                <rect width="14" height="16" fill="url(#pattern0_2809_1039_2)"></rect>
                <defs>
                  <pattern id="pattern0_2809_1039_2" patternContentUnits="objectBoundingBox" width="1" height="1">
                    <use xlink:href="#image0_2809_1039_2" transform="matrix(0.02 0 0 0.0175 0 -0.0075)"></use>
                  </pattern>
                  <image id="image0_2809_1039_2" width="50" height="58" xlink:href="data:image/png;base64,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"></image>
                </defs>
              </svg>
              </span>
              <span class="text-black hover:text-[#737373]">ANDROID</span>
            </a>
          </prestige-track>
        </li>
      </ul>
    </nav>
  </div>`,
  download_247_app_links: /* html */ `
  <div class="pt-2 mt-2" data-mission-shortcode="download_247_app_links">
    <nav>
      <ul class="grid grid-cols-1 justify-items-start leading-[25px] gap-2">
        <li>
          <prestige-track action="247_app_download">
            <a class="flex gap-2 items-center" href="https://apps.apple.com/gb/app/247/id1608017724" target="_blank" rel="noopener">
              <span title="ios" class="inline-flex shrink-0" aria-hidden="true">
                <svg width="17" height="18" viewBox="0 0 9 12" fill="none" xmlns="http://www.w3.org/2000/svg" class="w-[17px] h-[18px]">
                  <path d="M6.65321 3.17605L6.63439 3.17407C6.3318 3.14224 6.0057 3.23146 5.64896 3.36608C5.58728 3.38936 5.51224 3.41901 5.43523 3.44944C5.32912 3.49137 5.21926 3.53478 5.13549 3.56501C4.98112 3.62072 4.7757 3.68704 4.572 3.68704C4.37654 3.68704 4.1882 3.63349 4.03766 3.58181C3.92443 3.54295 3.80016 3.49301 3.68557 3.44697C3.64771 3.43176 3.6109 3.41697 3.5759 3.40314C3.26497 3.28034 3.00002 3.19499 2.74892 3.20012L2.74641 3.20017C2.00705 3.21156 1.29533 3.64246 0.900835 4.33354L0.899543 4.33581L0.899537 4.3358C0.487936 5.0482 0.417078 5.96587 0.583331 6.90818C0.74876 7.84581 1.13928 8.74672 1.56943 9.37552C1.8079 9.71661 2.03507 10.0297 2.27748 10.257C2.51919 10.4838 2.71216 10.5647 2.88041 10.5588C3.11416 10.5491 3.26953 10.4841 3.51733 10.3803C3.5317 10.3743 3.54638 10.3682 3.56141 10.3619C3.84463 10.2437 4.19497 10.1097 4.71769 10.1097C5.24353 10.1097 5.59268 10.2557 5.86586 10.3718C6.12531 10.4821 6.28166 10.5473 6.53037 10.5416L6.53414 10.5415C6.75032 10.5382 6.94526 10.4465 7.15713 10.2487C7.37927 10.0412 7.58251 9.75254 7.81303 9.40795L7.81995 9.3976L7.82008 9.39768C8.09513 9.00789 8.27787 8.62177 8.38611 8.35561C8.24205 8.26388 8.07735 8.14236 7.91311 7.98627C7.46946 7.56463 7.02591 6.88499 7.01708 5.88569L6.65321 3.17605ZM6.65321 3.17605L6.67213 3.1766C6.91203 3.1836 7.49898 3.25845 7.99014 3.69923L6.65321 3.17605ZM5.44618 1.16782L5.44683 1.16707C5.62709 0.955602 5.8871 0.773873 6.15032 0.653514C6.07526 0.94183 5.931 1.21873 5.74356 1.45458C5.54565 1.68617 5.2884 1.86786 5.02524 1.96794C5.10384 1.67239 5.26235 1.38262 5.44618 1.16782Z" stroke="currentColor" fill="black"/>
                </svg>
              </span>
              <span class="text-black hover:text-[#737373]">iOS</span>
            </a>
          </prestige-track>
        </li>
      </ul>
    </nav>
  </div>
  `
};




function buildQueryString(params) {
  if (!params || typeof params !== 'object' || Object.keys(params).length === 0) return '';
  return (
    '?' +
    Object.entries(params)
      .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
      .join('&')
  );
}

function getUrlParams(urlString) {
  const url = new URL(urlString);
  return Object.fromEntries(url.searchParams.entries());
}

function pluralize(count, singular, plural) {
  count = Number(count); // Ensure count is treated as a number
  return count === 1 ? singular || '' : plural || '';
}

function resolveShortcodes(html = '') {
  for (const [key, value] of Object.entries(SHORTCODES)) {
    html = html.replaceAll(`#${key}`, value);
  }
  return html;
}


class PrestigeConnectorApiService {
  /**
   * @param {PrestigeConnectorApiConfig} [config]
   */
  constructor(config = {}) {
    this.config = { ...window.PRESTIGE_CONNECTOR_API_CONFIG, ...config };
    this.tokenRefreshUrl = '/?section_id=prestige-token-refresh';
  }

  /**
   * @param {PrestigeGetOptions} [options]
   */
  async ping(options = {}) {
    return this.get('/ping', options);
  }

  /**
   *
   * @param {string} action Event to track
   * @param {object} data Data to track as part of the event
   * @param {object} options
   * @returns
   */
  async trackEvent(action, data = {}, options = {}) {
    return this.post('/prestige/track', {
      action,
      data,
    }, options);
  }

  async hideOnboarding(options = {}) {
    return this.patch('/customer-onboarding/hide', options);
  }

  async markOnboarded(options = {}) {
    return this.patch('/customer-onboarding/onboarded', options);
  }

  async markPreferencesSeen(options = {}) {
    return this.patch('/preferences/seen', options);
  }

  /**
   * Create customer preferences as customer metafields.
   *
   * @param {Object} preferences - Preferences object to create.
   * @param {string} [preferences.closest_store] - Customer's closest store (e.g. 'gid://shopify/Metaobject/1234') - Required on creation.
   * @param {string} preferences.birth_date - Date of birth in ISO format.
   * @param {'Mens'|'Womens'|'Both'} preferences.department - Single preference for department.
   * @param {string[]} preferences.styles - Array of style preferences (e.g., ['gid://shopify/Metaobject/12', 'gid://shopify/Metaobject/13']).
   * @param {string} preferences.clothing_size - Single clothing size preference.
   * @param {string} preferences.footwear_size - Single footwear size preference.
   * @param {PrestigePostOptions} [options]
   * @returns {Promise<Object>} Response from the API
   */
  async createCustomerPreferences(preferences, options = {}) {
    return this.post('/customer-preferences', preferences, options);
  }

  /**
   * Update customer preferences
   *
   * @param {Object} preferences - Preferences object to update.
   * @param {string} [preferences.closest_store] - Customer's closest store (e.g. 'gid://shopify/Metaobject/1234') - Optional on update.
   * @param {'Mens'|'Womens'|'Both'} preferences.department - Single preference for department.
   * @param {string[]} preferences.styles - Array of style preferences (e.g., ['gid://shopify/Metaobject/12', 'gid://shopify/Metaobject/13']).
   * @param {string} preferences.clothing_size - Single clothing size preference.
   * @param {string} preferences.footwear_size - Single footwear size preference.
   * @param {PrestigePostOptions} [options]
   * @returns {Promise<Object>} Response from the API
   */
  async updateCustomerPreferences(preferences, options = {}) {
    return this.patch('/customer-preferences', preferences, options);
  }

  /**
   * Partially update the logged-in customer (profile / contact / marketing).
   * Only keys present in the payload are updated; omitted fields are unchanged.
   *
   * @param {Object} payload - Only present keys are updated. Currently used: birth_date. More fields (phone, marketing, etc.) when supported by the connector.
   * @param {string} [payload.birth_date] - Date of birth (YYYY-MM-DD).
   * @param {PrestigePostOptions} [options]
   * @returns {Promise<Object>}
   */
  async updateCustomer(payload, options = {}) {
    return this.patch('/customer', payload, options);
  }

  /**
   * @param {PrestigeGetOptions} [options]
   */
  async getProfile(options = {}) {
    return this.get('/prestige', options);
  }

  /**
   * @param {PrestigeGetPointsHistoryOptions} [options]
   * @returns {Promise<ApiPaginatedResponse<PrestigePointsHistoryEntry>>}
   */
  async getPointsHistory(options = {}) {
    return this.get('/prestige/history', options);
  }

  /**
   * @param {string} rewardId
   * @param {Object} [options]
   * @returns {Promise<ApiResponse<PrestigeClaimReward>>}
   */
  async getClaimedRewards(options = {}) {
    return this.get('/prestige/rewards/claimed', options);
  }

  /**
   * @param {PrestigeGetAvailableRewardsOptions} [options]
   * @returns {Promise<ApiPaginatedResponse<PrestigeAvailableRewardEntry>>}
   */
  async getAvailableRewards(options = {}) {
    return this.get('/prestige/rewards/available', options);
  }

  /**
   * @param {string} rewardId
   * @param {Object} [options]
   * @returns {Promise<ApiResponse<PrestigeClaimReward>>}
   */
  async claimReward(rewardId, options = {}) {
    return this.post(`/prestige/rewards/${rewardId}/claim`, options);
  }

  /**
   * @param {PrestigeGetMissionsOptions} [options]
   * @returns {Promise<ApiPaginatedResponse<PrestigeMissionEntry>>}
   */
  async getMissions(options = {}) {
    return this.get('/prestige/missions', options);
  }

  /**
   * Get all missions sorted by progress status (for tabs page).
   * Fetches up to 100 missions and sorts by: in-progress first, then not started, then completed.
   * No pagination - returns all missions in a single response.
   * @returns {Promise<ApiResponse<PrestigeMissionEntry[]>>}
   */
  async getMissionsProgressions() {
    return this.get('/prestige/missions/progressions');
  }

  /**
   * @param {PrestigeGetOptions} [options]
   */
  async getTiers(options = {}) {
    if (typeof options.params === 'undefined') {
      options.params = {};
    }

    options.params.current_tier = this.config.customer.currentTier;

    return this.get('/prestige/tiers', options);
  }

  /**
   * @param {number} points
   * @param {string} recipientEmail
   * @returns {Promise<ApiResponse<PrestigeSharePoints>>}
   */
  async sharePoints(points, recipientEmail) {
    return this.post(`/prestige/share-points`, {
      data: {
        share_to_customer: recipientEmail,
        points: points,
      },
    });
  }

  /**
   * Make an authenticated request to the Prestige API
   *
   * @param {string} endpoint - API endpoint (without base URL)
   * @param {PrestigeRequestOptions} [options] - Fetch options (method, body, params, headers)
   * @returns {Promise} - Response data
   */
  async request(endpoint, options = {}) {
    const method = (options.method || 'GET').toUpperCase();
    if (method !== 'GET' && method !== 'POST' && method !== 'PATCH') {
      throw new Error('Only GET, POST, and PATCH are supported');
    }
    let url = `${this.config.baseUrl}${endpoint}`;
    if (options.params) {
      const params = options.params instanceof URLSearchParams ? options.params : new URLSearchParams(options.params);

      if (params.size > 0) {
        url += (url.includes('?') ? '&' : '?') + params.toString();
      }
    }
    return this._makeRequest(url, { ...options, method });
  }

  /**
   * Calculate exponential backoff delay for retries
   * @param {number} attempt - Current attempt number (0-indexed)
   * @param {number} baseDelay - Base delay in milliseconds (default: 500)
   * @param {boolean} useJitter - Whether to apply equal jitter (default: true)
   * @returns {number} Delay in milliseconds
   */
  _getRetryDelay(attempt, baseDelay = 500, useJitter = true) {
    const delay = baseDelay * Math.pow(2, attempt);

    if (useJitter) {
      // Equal jitter: random value between delay/2 and delay
      return delay / 2 + Math.random() * (delay / 2);
    }

    return delay;
  }

  /**
   * Internal method to make the actual fetch request
   *
   * @param {string} url
   * @param {PrestigeRequestOptions} [options]
   * @param {number} attempt
   */
  async _makeRequest(url, options = {}, attempt = 0) {
    const maxRetries = 3;

    const fetchOptions = {
      method: options.method,
      headers: {
        ...this.config.headers,
        ...options.headers,
      },
    };

    if (options.body && ['POST', 'PATCH'].includes(fetchOptions.method)) {
      fetchOptions.body = typeof options.body === 'string' ? options.body : JSON.stringify(options.body);
    }

    const response = await fetch(url, fetchOptions);

    // Handle 401 once
    if (response.status === 401 && attempt === 0) {
      const refreshed = await this._refreshToken();
      if (!refreshed) {
        throw new Error('Token refresh failed');
      }

      // retry request with new token
      const retryOptions = {
        ...options,
        headers: {
          ...options.headers,
          ...this.config.headers, // includes updated token
        },
      };
      return this._makeRequest(url, retryOptions, attempt + 1);
    }

    // Handle 429 rate limiting
    if (response.status === 429 && attempt < maxRetries) {
      const retryAfterHeader = response.headers.get('retry-after');
      let delay = this._getRetryDelay(attempt);

      if (retryAfterHeader) {
        const seconds = parseInt(retryAfterHeader, 10);
        if (!Number.isNaN(seconds)) {
          delay = seconds * 1000;
        } else {
          const retryDate = new Date(retryAfterHeader);
          const retryTime = retryDate.getTime();
          if (!Number.isNaN(retryTime)) {
            const now = Date.now();
            delay = Math.max(retryTime - now, 0);
          }
        }
      }

      await new Promise((resolve) => setTimeout(resolve, delay));
      return this._makeRequest(url, options, attempt + 1);
    }

    // Try to parse as JSON, fallback to text
    const contentType = response.headers.get('content-type');
    let result;
    if (contentType && contentType.includes('application/json')) {
      result = await response.json();
    } else {
      if (!response.ok) {
        throw new Error(`API request failed: ${response.status} ${response.statusText}`);
      }
      return await response.text();
    }

    // Handle "Customer not found" error with retry logic for GET requests
    const isCustomerNotFoundError =
      result &&
      result.success === false &&
      Array.isArray(result.errors) &&
      result.errors.includes('Customer not found');

    if (isCustomerNotFoundError && fetchOptions.method === 'GET' && attempt < maxRetries) {
      const delay = this._getRetryDelay(attempt, 2000);
      await new Promise((resolve) => setTimeout(resolve, delay));
      return this._makeRequest(url, options, attempt + 1);
    }

    if (!response.ok) {
      throw new Error(`API request failed: ${response.status} ${response.statusText}`);
    }

    return result;
  }

  /**
   * Fetch a new token and update config.headers
   * @returns {Promise<boolean>} success
   */
  async _refreshToken() {
    try {
      const res = await fetch(this.tokenRefreshUrl, { credentials: 'same-origin' });
      if (!res.ok) return false;

      // Parse the HTML from the section rendering respose
      const html = await res.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      // Grab the section content and parse as JSON
      const sectionElement = doc.querySelector('#shopify-section-prestige-token-refresh');
      const dataString = sectionElement?.innerHTML.trim();
      const data = JSON.parse(dataString);

      // update instance config
      this.config.headers = {
        ...this.config.headers,
        ...data,
      };
      return true;
    } catch (e) {
      console.error('Token refresh error', e);
      return false;
    }
  }

  /**
   * @param {string} endpoint
   * @param {PrestigeGetOptions} [options] (params, headers)
   */
  async get(endpoint, options = {}) {
    return this.request(endpoint, { ...options, method: 'GET' });
  }

  /**
   * @param {string} endpoint
   * @param {Object} data (body)
   * @param {PrestigePostOptions} [options] (params, headers)
   */
  async post(endpoint, data = null, options = {}) {
    return this.request(endpoint, {
      ...options,
      method: 'POST',
      body: data,
    });
  }

  /**
   * @param {string} endpoint
   * @param {Object} data (body)
   * @param {PrestigePostOptions} [options] (params, headers)
   */
  async patch(endpoint, data = null, options = {}) {
    return this.request(endpoint, {
      ...options,
      method: 'PATCH',
      body: data,
    });
  }
}

/**
 * @template T
 */
class ResourceState extends EventTarget {
  constructor() {
    super();
    /** @type {T|null} */
    this.data = null;

    /** @type {boolean} */
    this.isLoading = false;

    /** @type {string[]} */
    this.errors = [];

    /** @type {boolean} */
    this.hasMadeFirstRequest = false;
  }

  setLoading(loading = true) {
    this.isLoading = loading;
    if (loading) {
      this.errors = [];
    }
  }

  setData(data) {
    this.data = data;
    this.isLoading = false;
    this.errors = [];
  }

  setError(error) {
    this.errors = Array.isArray(error) ? error : [error];
    this.isLoading = false;
    this.data = null;
  }

  reset() {
    this.data = null;
    this.isLoading = false;
    this.errors = [];
    this.hasMadeFirstRequest = false;
  }

  emitChange() {
    this.dispatchEvent(new CustomEvent('change', { detail: { state: this } }));
  }

  markHasMadeFirstRequest() {
    this.hasMadeFirstRequest = true;
  }
}

/**
 * A simple loadable resource that encapsulates a single fetch call.
 *
 * @template T
 * @template TParams
 * @extends ResourceState<T>
 */
class LoadableResourceState extends ResourceState {
  /**
   * @param {(params?: TParams) => Promise<T>} fetcher
   */
  constructor(fetcher) {
    super();
    this._fetch = fetcher;
  }

  /**
   * Load the resource data.
   * @param {TParams} [params]
   */
  async load(params) {
    if (this.isLoading) return;

    this.setLoading(true);
    this.emitChange();

    try {
      this.markHasMadeFirstRequest();
      const result = await this._fetch(params);

      if (result && result.success === false) {
        this.setError(result.errors || ['Unknown error']);
      } else {
        this.setData(result.data ?? result);
      }
    } catch (err) {
      this.setError(err.message);
    }

    this.emitChange();
  }
}

/**
 * A paginated resource state that encapsulates fetching and accumulating pages.
 * Accumulates items into data.items and exposes hasNext.
 *
 * @template TItem
 * @template TParams
 * @extends ResourceState<import('./prestige-types').PaginatedResult<TItem, TParams>>
 */
class PaginatableResourceState extends ResourceState {
  /**
   * @param {(params?: TParams) => Promise<import('./prestige-types').PaginatedResult<TItem, TParams>>} fetchPage
   * @param {string} key
   */
  constructor(fetchPage, key) {
    super();
    this._fetchPage = fetchPage;
    this._keySelector = (item) => String(item?.[key]);
    /** @type {TParams|null} */
    this._next = null;
    /** @type {TParams|null} */
    this._previous = null;
    /** @type {number} */
    this._total = 0;
  }

  /** @returns {boolean} */
  get hasNext() {
    return !!this._next;
  }

  /**
   * @param {TParams} [params]
   */
  async load(params) {
    if (this.isLoading) return;

    this.setLoading(true);
    this.emitChange();

    try {
      this.markHasMadeFirstRequest();
      const result = await this._fetchPage(params);

      if (result && result.success === false) {
        this.setError(result.errors || ['Unknown error']);
      } else {
        this.setPaginatedData(this._normalize(result));
      }
    } catch (err) {
      this.setError(err.message);
    }

    this.emitChange();
  }

  /**
   * Load the next page based on the internally stored next params and append.
   */
  async loadNext() {
    if (this.isLoading || !this._next) return;

    this.setLoading(true);
    this.emitChange();

    try {
      const result = await this._fetchPage(this._next);

      if (result && result.success === false) {
        this.setError(result.errors || ['Unknown error']);
      } else {
        this.setPaginatedData(this._normalize(result), true);
      }
    } catch (err) {
      this.setError(err.message);
    }

    this.emitChange();
  }

  setPaginatedData(normalized, append = false) {
    const next = normalized.next;
    const previous = normalized.previous;
    const incoming = normalized.items;

    const current = append && this.data && Array.isArray(this.data.items) ? this.data.items : [];
    const merged = append ? this._dedupeByKey([...current, ...incoming]) : incoming;

    this._next = next;
    this._previous = previous;
    this._total = normalized.total;

    this.setData({ items: merged, next, previous, total: this._total });
  }

  _dedupeByKey(items) {
    const seen = new Set();
    return items.filter((item) => {
      try {
        const key = this._keySelector(item);
        if (seen.has(key)) return false;
        seen.add(key);
        return true;
      } catch (_) {
        return true;
      }
    });
  }

  // Accepts either already-normalized shape or a Prestige-like response and converts it
  _normalize(raw) {
    if (raw && Array.isArray(raw.items)) {
      return raw;
    }

    const items = raw.data;
    const next = typeof raw.next === 'string' ? getUrlParams(raw.next) : null;
    const previous = typeof raw.previous === 'string' ? getUrlParams(raw.previous) : null;
    const total = raw.total;
    return { items, next, previous, total };
  }
}

class PrestigeStore {
  /**
   * @param {PrestigeConnectorApiService} api
   */
  constructor(api) {
    this.api = api;

    /** @type {LoadableResourceState<PrestigeProfile>} */
    this.profile = new LoadableResourceState((extendParams = {}) =>
      this.api.getProfile({
        params: {
          ...extendParams,
        },
      }),
    );

    /** @type {LoadableResourceState<PrestigeTiers>} */
    this.tiers = new LoadableResourceState((extendParams = {}) =>
      this.api.getTiers({
        params: {
          ...extendParams,
        },
      }),
    );

    /** @type {PaginatableResourceState<PrestigePointsHistoryEntry, PrestigePointsHistoryParams> & ResourceState<PrestigePointsHistory>} */
    this.pointsHistory = new PaginatableResourceState(
      (extendParams = {}) =>
        this.api.getPointsHistory({
          params: { order: 'desc', limit: 6, ...extendParams },
        }),
      'id',
    );

    /** @type {PaginatableResourceState<PrestigeMissionEntry, PrestigeMissionParams> & ResourceState<PrestigeMissions>} */
    this.missions = new PaginatableResourceState(
      (extendParams = {}) =>
        this.api.getMissions({
          params: { order: 'desc', sort: 'title', limit: 6, ...extendParams },
        }),
      'id',
    );

    /** @type {LoadableResourceState<PrestigeMissionEntry[]>} */
    this.missionsProgressions = new LoadableResourceState(
      () => this.api.getMissionsProgressions(),
    );

    /** @type {LoadableResourceState<PrestigeClaimedReward[]>} */
    this.claimedRewards = new LoadableResourceState(
      (extendParams = {}) =>
        this.api.getClaimedRewards({
          params: {
            ...extendParams,
          },
        }),
      'id',
    );

    /** @type {PaginatableResourceState<PrestigeAvailableRewardEntry, PrestigeAvailableRewardParams> & ResourceState<PrestigeAvailableRewards>} */
    this.availableRewards = new PaginatableResourceState(
      (extendParams = {}) =>
        this.api.getAvailableRewards({
          params: {
            limit: 6,
            sort: 'order',
            order: 'desc',
            fields: 'instructions',
            ...extendParams,
          },
        }),
      'id',
    );
  }
}

class AttributeBinder {
  constructor(nodeElementToHydrate, targetNode, bindings) {
    this.nodeElementToHydrate = nodeElementToHydrate;
    this.targetNode = targetNode;
    this.bindings = bindings;
  }

  hydrate() {
    const resolve = (obj, path) => path.split('.').reduce((a, k) => (a == null ? undefined : a[k]), obj);

    this.nodeElementToHydrate.querySelectorAll('[data-bind]').forEach((el) => {
      const path = el.getAttribute('data-bind');
      if (!path) return;
      const value = resolve(this.bindings, path);
      if (value != null) el.textContent = String(value);
    });
  }

  commit() {
    this.targetNode.replaceChildren(this.nodeElementToHydrate);
  }
}

class PrestigeBaseElement extends HTMLElement {
  constructor() {
    super();
    this.store = window.prestigeStore;
    this._boundRender = this._renderInternal.bind(this);
    this._initialContent = null;

    this._visibilityObserver = null;
    this._visibleCleanup = null;
  }

  connectedCallback() {
    if (!this._initialContent) {
      this._initialContent = this.innerHTML;
    }

    const dependencies = this.dependencies && typeof this.dependencies === 'function' ? this.dependencies() : [];

    if (Array.isArray(dependencies)) {
      dependencies.forEach((dep) => {
        if (dep instanceof ResourceState === false) {
          throw new Error(
            `Invalid dependency: expected instance of ResourceState, but got ${dep?.constructor?.name ?? typeof dep}`,
          );
        }
        dep.addEventListener('change', this._boundRender);
      });
    }
    this.onConnected?.();

    // Schedule optional visibility hook: derived components may implement onVisible()
    if (typeof this.onVisible === 'function') {
      const defaultVisibleOptions = { once: true, root: null, rootMargin: '0px', threshold: 0.01 };
      const customVisibleOptions = (this.constructor && this.constructor.visibleOptions) || {};
      const options = { ...defaultVisibleOptions, ...customVisibleOptions };
      this._visibleCleanup = this.whenVisible(() => this.onVisible(), options);
    }
  }

  disconnectedCallback() {
    const dependencies = this.dependencies && typeof this.dependencies === 'function' ? this.dependencies() : [];
    if (Array.isArray(dependencies)) {
      dependencies.forEach((dep) => {
        if (dep instanceof ResourceState === false) {
          throw new Error(
            `Invalid dependency: expected instance of ResourceState, but got ${dep?.constructor?.name ?? typeof dep}`,
          );
        }
        dep.removeEventListener('change', this._boundRender);
      });
    }
    this.onDisconnected?.();

    if (this._visibilityObserver) {
      this._visibilityObserver.disconnect();
      this._visibilityObserver = null;
    }

    if (typeof this._visibleCleanup === 'function') {
      this._visibleCleanup();
      this._visibleCleanup = null;
    }
  }

  /**
   * Run a callback when this element becomes visible in the viewport.
   * Returns a cleanup function to stop observing.
   * Defaults to running once on first visibility.
   */
  whenVisible(callback, options = {}) {
    const { once = true, root = null, rootMargin = '0px', threshold = 0.01 } = options;

    const observer = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (entry.isIntersecting) {
            callback(entry);
            if (once) {
              observer.disconnect();
              if (this._visibilityObserver === observer) this._visibilityObserver = null;
            }
            break;
          }
        }
      },
      { root, rootMargin, threshold },
    );

    observer.observe(this);
    this._visibilityObserver = observer;

    return () => {
      observer.disconnect();
      if (this._visibilityObserver === observer) this._visibilityObserver = null;
    };
  }

  _renderInternal() {
    const deps = this.dependencies && typeof this.dependencies === 'function' ? this.dependencies() : [];
    const dependenciesHaveMadeFirstRequest =
      Array.isArray(deps) && deps.every((d) => d && d.hasMadeFirstRequest === true);

    // If no dependency has requested yet, keep the initial light DOM
    if (dependenciesHaveMadeFirstRequest === false) {
      return;
    }

    const output = this.render();

    if (output instanceof AttributeBinder) {
      output.hydrate();
      output.commit();
      return;
    }

    if (typeof output === 'string') {
      this.innerHTML = output;
      return;
    }
  }

  getLocalizedDisplayValue(value) {
    const locale = Shopify.locale;
    const localized = value?.[locale];

    return localized ? localized : value?.en;
  }

  html(strings, ...values) {
    // Flatten arrays and join everything
    const flattened = values.map((v) => (Array.isArray(v) ? v.join('') : v.toString()));
    return strings.reduce((acc, str, i) => acc + str + (flattened[i] || ''), '');
  }

  mount(bindings) {
    const template = document.createElement('template');
    template.innerHTML = this._initialContent;

    const fragmentToHydrate = template.content.cloneNode(true);
    return new AttributeBinder(fragmentToHydrate, this, bindings);
  }

  /**
   * @returns {Array<ResourceState<T>>}
   */
  dependencies() {
    return [];
  }

  /**
   * @returns {string|AttributeBinder}
   */
  render() {}
}

/// <reference path="./prestige-connector-api.js" />
// @ts-check

/**
 * Wraps a link or button and calls PrestigeConnectorApiService.trackEvent
 * before the default action (navigation/click) runs. Tracking is fire-and-forget;
 * errors are logged and never block the user action.
 *
 * Usage:
 *   <prestige-track action="represent_app_download">
 *     <script type="application/json">{"platform":"ios","location":"footer"}</script>
 *     <a href="https://apps.apple.com/...">Download on the App Store</a>
 *   </prestige-track>
 *
 * Requires: action attribute. Optional child <script type="application/json"> for payload.
 * Clickable child: first matching a, button, or [role="button"].
 */
class PrestigeTrack extends PrestigeBaseElement {
  constructor() {
    super();
    /** @type {string | null} */
    this._action = null;
    /** @type {Object} */
    this._data = {};
    /** @type {((e: MouseEvent) => void) | null} */
    this._boundClick = null;
    /** @type {Element | null} */
    this._clickable = null;
  }

  onConnected() {
    this._action = this.getAttribute('action');
    this._data = this.parseJsonScript(this);
    this._clickable = this.querySelector('a, button, [role="button"]');

    if (!this._clickable) {
      console.error(`[prestige-track] No clickable child found (a, button, [role="button"]).`);
      return;
    }

    if (!this.store?.api) {
      console.error(`[prestige-track] Prestige store/api is not available. Tracking will be skipped.`);
      return;
    }

    this._boundClick = this._onClick.bind(this);
    this._clickable.addEventListener('click', /** @type {EventListener} */ (this._boundClick), { capture: true });
  }

  onDisconnected() {
    if (this._clickable && this._boundClick) {
      this._clickable.removeEventListener('click', /** @type {EventListener} */ (this._boundClick), { capture: true });
    }
    this._clickable = null;
    this._boundClick = null;
  }

  parseJsonScript(el) {
    const script = el.querySelector('script[type="application/json"]');
    if (!script) return {};
    const raw = (script.textContent || '').trim();
    try {
      return JSON.parse(raw);
    } catch (err) {
      console.error(`[prestige-track] Invalid JSON in script[type="application/json"]:`, err);
      return {};
    }
  }

  _onClick(_e) {
    if (!this.store?.api || !this._action) return;

    try {
      const promise = this.store.api.trackEvent(this._action, this._data);
      if (promise && typeof promise.catch === 'function') {
        promise.catch(function (err) {
          console.error(`[prestige-track] trackEvent failed:`, err);
        });
      }
    } catch (err) {
      console.error(`[prestige-track] trackEvent error:`, err);
    }
  }
}

customElements.define('prestige-track', PrestigeTrack);


// Initialize global instances
window.prestigeStore = new PrestigeStore(new PrestigeConnectorApiService());
window.PrestigeBaseElement = PrestigeBaseElement;

if (window.prestigeStore.api.config.customer.isLoggedIn && !window.prestigeStore.api.config.customer.optInDate) {
  window.prestigeStore.api.get('/prestige/sync');
}
